import { render, staticRenderFns } from "./CFNoteLayout.vue?vue&type=template&id=81d6e4d4&"
import script from "./CFNoteLayout.vue?vue&type=script&lang=ts&"
export * from "./CFNoteLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports